import parseImageId from "./parseImageId";
import loadFileRequest from "./loadFileRequest.js";
import { xhrRequest } from "../internal/index.js";
import Cache from "core/cache/index";
import pubsub from "core/global/global";
import Loader from "core/loader/index";
import Helper from "core/helper/index";
import CustomEvent from "core/customEvent/index";
import FloatMessageBox from "core/messageBoxController/index";

function getLoaderForScheme(scheme) {
  if (scheme === "dicomweb" || scheme === "wadouri") {
    return xhrRequest;
  } else if (scheme === "dicomfile") {
    return loadFileRequest;
  }
}

//function loadImage(imageId, options) {
function get(imageId, options) {
  const parsedImageId = parseImageId(imageId);
  const loader = getLoaderForScheme(parsedImageId.scheme);

  /**
   * 1. Cache에 이미 로드된 데이터인지 확인. 로드된 데이터라면, 로드 진행하지 않음.
   */

  // This uri is not loaded or being loaded, load it via an xhrRequest
  //const loadDICOMPromise = loadRequest(uri, imageId);
  const loadDICOMPromise = loader(parsedImageId.url, imageId);

  // handle success and failure of the XHR request load
  //const promise = new Promise((resolve, reject) => {
  new Promise((resolve, reject) => {
    loadDICOMPromise.then(function(dicomPart10AsArrayBuffer /* , xhr*/) {
      pubsub.publish(CustomEvent.Messages.INIT_VIEWPORT, {});
      const byteArray = new Uint8Array(dicomPart10AsArrayBuffer);

      // remove mime header
      let readLength = 200;
      if (readLength > byteArray.length) {
        readLength = byteArray.length;
      }
      let countNewLine = 0;
      let realDicomData = [];
      for (let i = 0; i < readLength; i++) {
        const byte = byteArray[i];
        if (byte === 13) {
          countNewLine++;
        }

        if (countNewLine === 4) {
          realDicomData = byteArray.slice(i + 2, byteArray.length - 42);
          break;
        }
      }
      try {
        let dicomLoader = new Loader.LoaderDicom();
        dicomLoader
          //.parseFile(parsedImageId.url, byteArray)
          .parseFile(parsedImageId.url, realDicomData)
          .then(function(data) {
            let metadataCache = new Cache.Metadata();
            const seriesInstanceUID = data.seriesInstanceUID;
            const modality = data.modality;
            if (
              !Helper.Validator.isString(seriesInstanceUID) ||
              !Helper.Validator.isString(modality)
            ) {
              console.error(
                "DICOM Data Type is not correct : seriesInstanceUID or modality"
              );
              return;
            }

            metadataCache.add(seriesInstanceUID, modality, data);
          })
          .catch(function(err) {
            console.error(err);
          });
      } catch (ex) {
        const parameters = {
          title: "Warning",
          message: "This data is not supported format",
          buttonType: "OK",
          hasCloseButton: false,
          hasTodayOffButton: false
        };
        FloatMessageBox(parameters);
      }

      resolve();
    }, reject);
  });
}

const WadoURIProvider = {
  //loadImage
  get
};
export default WadoURIProvider;
